import { MarketingProvider } from "../features/marketing/marketing-provider";

import { Suspense } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";

import { RouteRobotsProvider } from "../shared/seo/route-robots";
import { SkeletonRegion } from "../shared/ui/async-boundary";

export function RouteBoundary() {
  return (
    <RouteRobotsProvider>
      <MarketingProvider>
      <Suspense
        fallback={
          <SkeletonRegion fullscreen label="Carregando interface" />
        }
      >
        <Outlet />
      </Suspense>
      {/* New pages open at the top; back/forward restores the previous position. */}
      <ScrollRestoration />
    </MarketingProvider>
    </RouteRobotsProvider>
  );
}
